import { useState } from 'react'
import { X, AlertTriangle } from 'lucide-react'
import './BetaBanner.css'

const STORAGE_KEY = 'sb:beta-banner-dismissed'

/**
 * Non-blocking beta warning banner above the topbar.
 * Dismissed state persists via localStorage.
 */
export default function BetaBanner() {
    const [dismissed, setDismissed] = useState(
        () => localStorage.getItem(STORAGE_KEY) === '1'
    )
    const [hiding, setHiding] = useState(false)

    if (dismissed) return null

    const handleDismiss = () => {
        setHiding(true)
        // Let the slide-up animation finish before removing from DOM
        setTimeout(() => {
            localStorage.setItem(STORAGE_KEY, '1')
            setDismissed(true)
        }, 250)
    }

    return (
        <div className={`beta-banner ${hiding ? 'beta-banner--hiding' : ''}`} role="status">
            <AlertTriangle size={14} className="beta-banner-icon" />
            <span className="beta-banner-text">
                Beta — Använd på egen risk, din data kan gå förlorad.
            </span>
            <button
                className="beta-banner-dismiss"
                onClick={handleDismiss}
                aria-label="Stäng"
            >
                <X size={14} />
            </button>
        </div>
    )
}
